/**
 * @file: context.tsx
 *
 * The app-wide feed unread-count store context — the single global concern of
 * the feed flow (the inbox tab badge, sidebar drawer item, and dashboard
 * burger badge all read the same count). Provided by `FeedUnreadProvider`
 * (see `./provider`) and read via `useFeedUnreadStore()`.
 */

import { createContext, useContext } from 'react';
import { BehaviorSubject } from 'rxjs';

export interface FeedUnreadStore {
  feedUnreadCount$: BehaviorSubject<number>;
  /** Reconcile the unread total from the server (deduped). */
  refreshFeedUnread: () => Promise<void>;
}

export const FeedUnreadContext = createContext<FeedUnreadStore | null>(null);

export function useFeedUnreadStore(): FeedUnreadStore {
  const ctx = useContext(FeedUnreadContext);
  if (!ctx) {
    throw new Error(
      'useFeedUnreadStore must be used within a FeedUnreadProvider',
    );
  }
  return ctx;
}
